<template>
    <div
        :class="[
            'title-link p-4 md:p-6 bg-white justify-start align-top w-full',
            classes,
        ]">
        <div class="relative border-box px-10 w-full">
            <div
                class="left-align absolute left-0 lg:-left-3 top-0 text-[--colour-theme-text-text-mute] mb-10">
                <NuxtLink
                    :to="props.backLink"
                    class="action-btn back-button flex flex-row cursor-pointer lg:pl-2">
                    <Icon
                        class="mr-2 icon-outline-chevron pointer-events-none"
                        icon="chevron-left"
                        alt="chevron left" />
                    <p v-if="props.label">{{ props.label }}</p>
                </NuxtLink>
            </div>
            <div class="center-align text-center w-full date-time">
                <p
                    v-if="showDate"
                    class="title font-Open font-bold">
                    {{ formatDate(bookingState.selected_date) }}
                </p>
                <p
                    v-if="showTime"
                    class="title font-Open">
                    &nbsp;
                    {{ dynamicTime.start_time }} - {{ dynamicTime.end_time }}
                </p>
            </div>
            <NuxtLink
                to="/date"
                v-if="props.showEdit"
                class="text-link date-button cursor-pointer absolute right-0 top-0">
                <div class="text-wrapper text-highlight">Edit</div>
            </NuxtLink>
        </div>
    </div>
</template>

<script setup>
    import { formatDate, convertTo12Hour } from '@/helpers/dateFormats';
    import { useBookingStore } from '@/stores/booking';
    import { useStateStore } from '@/stores/state';

    const { state: bookingState } = useBookingStore();
    const { state: applicationState } = useStateStore();

    const dynamicTime = computed(() => {
        const times = applicationState.is24HourFormat
            ? {
                  start_time: bookingState.start_time,
                  end_time: bookingState.end_time,
              }
            : {
                  start_time: convertTo12Hour(bookingState.start_time),
                  end_time: convertTo12Hour(bookingState.end_time),
              };
        return times;
    });

    const props = defineProps({
        classes: {
            type: String,
            default: 'block',
        },
        showDate: { type: Boolean, default: true },
        showTime: { type: Boolean, default: false },
        showEdit: { type: Boolean, default: false },
        label: String,
        backLink: String,
    });
</script>
